import React, { ReactNode } from 'react';
import { useAuth } from '../../context/AuthContext';

interface BackendErrorHandlerProps {
  children: ReactNode;
}

const BackendErrorHandler: React.FC<BackendErrorHandlerProps> = ({ children }) => {
  const { backendError, clearErrors } = useAuth();

  if (backendError) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
              Service Error
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              We're experiencing some technical difficulties. Please try again.
            </p>
            <div className="mt-4 p-4 bg-red-100 border border-red-300 rounded">
              <p className="text-sm text-red-700">{backendError}</p>
            </div>
            <div className="mt-4 space-x-4">
              <button
                onClick={clearErrors}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
              >
                Try Again
              </button>
              <button
                onClick={() => window.location.reload()}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
              >
                Refresh Page
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default BackendErrorHandler;
